
import { defineComponent } from 'vue';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'FieldBig1',
  props: {
    label: {
      type: String,
      default: () => undefined,
    },
    value: {
      type: [Number, String],
      default: () => undefined,
    },
    value1: {
      type: Boolean,
      default: () => undefined,
    },
  },
  components: {
    CaretUpOutlined,
    CaretDownOutlined,
  },
});
